// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oN9n","buttons":"styles_buttons__I8j9h"};